import { ResponsiveImage as HygraphResponsiveImage } from '@/lib/types';

import { ResponsiveHygraphImageProps } from '@/components/responsive-hygraph-image';

import hygraphImageTransformer from '@/hygraph/transformers/hygraph-image.transformer';

export default function responsiveHygraphImageTransformer(
  responsiveImage: HygraphResponsiveImage
): ResponsiveHygraphImageProps | undefined {
  const desktopImage = hygraphImageTransformer(responsiveImage.desktopImage);

  if (!desktopImage) {
    return undefined;
  }

  return {
    desktopImage,
    mobileImage: hygraphImageTransformer(responsiveImage.mobileImage),
  };
}
